<div class="col-12 col-md-12 mt-2 explorer-container">
  <div class="widget-container fluid-height">
    <div class="stf-explorer">
      <div class="heading">
        <div class="input-group search-bar">
          <span class="input-group-btn">
            <button class="btn btn-light btn-outline-primary" (click)="dirUp()">
              <i class="fa fa-level-up"></i>
            </button>
          </span>
          <input type="search" autocorrect="off" autocapitalize="off" spellcheck="false" class="form-control"
            placeholder="Search" [(ngModel)]="searchText" name="searchText"/>
        </div>
      </div>

      <div class="widget-content padded selectable">
        <table class="table table-hover table-condensed">
          <thead>
            <tr>
              <th>{{ "Name" | translate }}</th>
              <th>{{ "Size" | translate }}</th>
              <th>{{ "Date" | translate }}</th>
              <th>{{ "Permissions" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (f of filteredFiles; track f) {
              <tr>
                <td>
                  @if (f.isDirectory) {
                    <button class="btn btn-sm btn-outline-primary" (click)="dirEnter(f.name)">
                      <i class="fa fa-folder-open folder-icon"></i>
                      {{ f.name }}
                    </button>
                  }
                  @if (!f.isDirectory) {
                    <button class="btn btn-sm btn-outline-primary" (dblclick)="getFile(f.name)"
                      title="Double click on the file to download">
                      <i class="fa fa-file-o file-icon"></i>
                      {{ f.name }}
                    </button>
                  }
                </td>
                <td>
                  @if (f.isDirectory) {
                    <span>-</span>
                  }
                  @if (!f.isDirectory) {
                    <span>
                      {{ f.size | explorerFilter : 'formatFileSize' }}
                    </span>
                  }
                </td>
                <td>{{ f.mtime | explorerFilter : 'formatFileDate' }}</td>
                <td>
                <i [ngClass]="{
                    'permission-full': (f.mode | explorerFilter : 'formatPermissionMode') === 'rwxrwxrwx',
                    'permission-limited': (f.mode | explorerFilter : 'formatPermissionMode') !== 'rwxrwxrwx'
                  }">
                    {{ f.mode | explorerFilter : 'formatPermissionMode' }}
                  </i>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>